<template>
  <div>
    <b-sidebar
      id="tilesettings"
      width="320px"
      right
      shadow
      text-variant="light"
      :title="title"
      v-model="show"
      class="tilesettings"
    >
      <b-card>
        <b-card-sub-title class="text-muted mb-2">{{tile.name}} Tile</b-card-sub-title>
        <!-- {{values}} -->
        <b-tabs card small pills v-model="paneindex">
          <b-tab
            v-for="(pane,index) in panes"
            :key="index"
            :title="pane.name"
            :active="index==paneindex"
          >
            <b-form-group
              v-for="(field,index) in pane.fields"
              :key="field.key"
              :hidden="(field.hidden)? (field.hidden.includes(action)):false"
              label-cols="12"
              l
              :label="field.label+':'"
              :label-for="`key-${field.label}`"
            >
              <!-- "form.values[index]" -->
              <b-form-input
                v-if="field.type=='text'||field.type=='number'||field.type=='email'||field.type=='password'||field.type=='search'||field.type=='url'||field.type=='tel'||field.type=='date'||field.type=='time'||field.type=='range'||field.type=='color'"
                v-model="values[field.index]"
                :id="`key-${field.key}`"
                :type="field.readonly?'text':field.type"
                :placeholder="(field.placeholder)?field.placeholder:''"
                :readonly="(field.readonly)?(field.readonly.includes(action)):false"
                :state="fieldValid(field,values[index])"
                :hidden="(field.hidden)? (field.hidden.includes(action)):false"
                :class="field.class?field.class:''"
                :size="field.size?field.size:'sm'"
                :min="field.min?field.min:null"
                :max="field.max?field.max:null"
                @keyup.native="isChanged()"
              ></b-form-input>

              <b-form-tags
                v-if="field.type==='tags'"
                v-model="values[field.index]"
                tag-variant="primary"
                :placeholder="(field.placeholder)?field.placeholder:''"
                :size="field.size?field.size:'sm'"
              ></b-form-tags>

              <b-form-checkbox
                v-if="field.type==='checkbox'"
                v-model="values[field.index]"
                :placeholder="(field.placeholder)?field.placeholder:''"
                :switch="field.switch?field.switch:null"
                :class="field.class?field.class:null"
                :size="field.size?field.size:'lg'"
                class="mt-1"
              >
                <span class="small">{{field.text}}</span>
              </b-form-checkbox>

              <b-form-select
                v-if="field.type==='select'"
                v-model="values[field.index]"
                :placeholder="(field.placeholder)?field.placeholder:''"
                :options="field.values?field.values:[]"
                :class="field.class?field.class:null"
                :size="field.size?field.size:'sm'"
              ></b-form-select>

              <b-form-rating
                v-if="field.type==='rating'"
                v-model="values[field.index]"
                :placeholder="(field.placeholder)?field.placeholder:''"
                :variant="field.variant?field.variant:null"
                :options="field.values?field.values:[]"
                :class="field.class?field.class:null"
                :size="field.size?field.size:'sm'"
                :color="field.color?field.color:null"
              ></b-form-rating>

              <b-form-radio-group
                v-if="field.type==='radio-group'"
                v-model="values[field.index]"
                :buttons="field.buttons?field.buttons:false"
                :button-variant="field['button-variant']?field['button-variant']:null"
                :options="field.values?field.values:[]"
                :size="field.size?field.size:'sm'"
              ></b-form-radio-group>

              <b-form-datepicker
                v-if="field.type==='datepicker'"
                v-model="values[field.index]"
                :size="field.size?field.size:'sm'"
                :required="field.required?field.required:null"
                :disabled="field.disabled?field.disabled:null"
                :min="field.min?field.min:null"
                :max="field.max?field.max:null"
                :date-format-options="field['date-format-options']?field['date-format-options']:{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short'}"
                :start-weekday="field['start-weekday']?field['start-weekday']:1"
                label-help
                hide-header
                locale="en-GB"
              ></b-form-datepicker>

              <b-form-timepicker
                v-if="field.type==='timepicker'"
                v-model="values[field.index]"
                :size="field.size?field.size:'sm'"
                :required="field.required?field.required:null"
                :disabled="field.disabled?field.disabled:null"
                :min="field.min?field.min:null"
                :max="field.max?field.max:null"
                hide-header
              ></b-form-timepicker>

              <div v-if="field.type==='datetimepicker'">
                <b-row no-gutters>
                  <b-col cols="8" class="pr-1">
                    <label>{{field.label_date}}:</label>
                    <b-form-datepicker
                      v-model="values[field.index]"
                      :size="field.size?field.size:'sm'"
                      :required="field.required?field.required:null"
                      :disabled="field.disabled?field.disabled:null"
                      :min="field.min?field.min:null"
                      :max="field.max?field.max:null"
                      :date-format-options="field['date-format-options']?field['date-format-options']:{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short'}"
                      :start-weekday="field['start-weekday']?field['start-weekday']:1"
                      label-help
                      hide-header
                      locale="en-GB"
                    ></b-form-datepicker>
                  </b-col>
                  <b-col>
                    <label>{{field.label_time}}:</label>
                    <b-form-timepicker
                      v-model="values[field.index]"
                      :size="field.size?field.size:'sm'"
                      :required="field.required?field.required:null"
                      :disabled="field.disabled?field.disabled:null"
                      :min="field.min?field.min:null"
                      :max="field.max?field.max:null"
                      label-no-time-selected="None"
                      hide-header
                    ></b-form-timepicker>
                  </b-col>
                </b-row>
              </div>

              <div v-if="field.type==='daterange'">
                <b-row no-gutters>
                  <b-col class="pr-1">
                    <b-form-datepicker
                      v-model="values[field.index]"
                      :size="field.size?field.size:'sm'"
                      :required="field.required?field.required:null"
                      :disabled="field.disabled?field.disabled:null"
                      :min="field.min?field.min:null"
                      :max="field.max?field.max:null"
                      :date-format-options="field['date-format-options']?field['date-format-options']:{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short'}"
                      :start-weekday="field['start-weekday']?field['start-weekday']:1"
                      label-help
                      hide-header
                      locale="en-GB"
                    ></b-form-datepicker>
                  </b-col>
                  <b-col>
                    <b-form-datepicker
                      v-model="values[field.index]"
                      :size="field.size?field.size:'sm'"
                      :required="field.required?field.required:null"
                      :disabled="field.disabled?field.disabled:null"
                      :min="field.min?field.min:null"
                      :max="field.max?field.max:null"
                      :date-format-options="field['date-format-options']?field['date-format-options']:{ year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short'}"
                      :start-weekday="field['start-weekday']?field['start-weekday']:1"
                      label-help
                      hide-header
                      locale="en-GB"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
              </div>

              <div v-if="field.type==='monthrange'">
                <!-- {{month_ddl}} / {{values[field.index]}} -->
                <b-input-group>
                  <section v-if="field.seed=='forward'">
                    <b-dropdown
                      size="sm"
                      :text="$moment().add(12-month_ddl, 'months').startOf('month').format('MMMM YYYY')"
                      variant="primary"
                    >
                      <b-dropdown-item
                        v-for="n in 12"
                        :key="n"
                        @click="month_ddl=n;values[field.index]=$moment().add(12-n, 'months').startOf('month').format('DD/MM/YYYY')"
                      >{{$moment().add(12-n, 'months').format('MMMM YYYY')}}</b-dropdown-item>
                    </b-dropdown>
                  </section>
                  <section v-else>
                    <b-dropdown
                      size="sm"
                      :text="$moment().subtract(12-month_ddl, 'months').startOf('month').format('MMMM YYYY')"
                      variant="primary"
                    >
                      <b-dropdown-item
                        v-for="n in 12"
                        :key="n"
                        @click="month_ddl=n;values[field.index]=$moment().subtract(12-n, 'months').startOf('month').format('DD/MM/YYYY')"
                      >{{$moment().subtract(12-n, 'months').format('MMMM YYYY')}}</b-dropdown-item>
                    </b-dropdown>
                  </section>
                </b-input-group>
              </div>

              <div v-if="field.type==='repositoryrange'">
                <b-input-group>
                  <b-dropdown
                    size="sm"
                    :text="repository_ddl?repository_ddl:values[field.index]"
                    variant="primary"
                  >
                    <b-dropdown-item
                      v-for="(name, index) in ['repositoryFO','repositoryBO','repositoryAO','repositoryMO','repositoryCO','repositoryCR','repositoryGTT','repositorySTB']"
                      :key="index"
                      @click="repository_ddl=name;values[field.index]=name"
                    >{{name}}</b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </div>

              <b-form-textarea
                v-if="field.type==='textarea'"
                id="textarea"
                v-model="values[field.index]"
                :placeholder="(field.placeholder)?field.placeholder:''"
                @keyup.native="isChanged()"
                :rows="field.rows?field.rows:3"
                :max-rows="field['max-rows']?field['max-rows']:6"
              ></b-form-textarea>

              <b-form-spinbutton
                v-if="field.type==='spinbutton'"
                id="spinbutton"
                v-model="values[field.index]"
                :placeholder="(field.placeholder)?field.placeholder:''"
                :size="field.size?field.size:'lg'"
                :min="field.min?field.min:null"
                :max="field.max?field.max:null"
              ></b-form-spinbutton>

              <div v-if="field.type==='fontsize'">
                <b-row no-gutters>
                  <b-col cols="8" class="pr-1">
                    <label>{{field.label_type}}:</label>
                    <b-form-select
                      v-model="values[field.index]"
                      :placeholder="(field.placeholder)?field.placeholder:''"
                      :options="field.values_type?field.values_type:[]"
                      :class="field.class?field.class:null"
                      :size="field.size?field.size:'sm'"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <label>{{field.label_size}}:</label>
                    <b-form-select
                      v-model="values[field.index]"
                      :placeholder="(field.placeholder)?field.placeholder:''"
                      :options="field.values_size?field.values_size:[]"
                      :class="field.class?field.class:null"
                      :size="field.size?field.size:'sm'"
                    ></b-form-select>
                  </b-col>
                </b-row>
              </div>

              <div v-if="field.type==='duration'">
                <treeselect
                  :clearable="false"
                  v-model="values[field.index]"
                  :options="[ 
                    {id: '2', label: '2 Nights' },
                    {id: '3', label: '3 Nights' },
                    {id: '4', label: '4 Nights' },
                    {id: '5', label: '5 Nights' },
                    {id: '6', label: '6 Nights' },
                    {id: '7', label: '7 Nights' },
                  ]"
                />
              </div>

              <!-- @change.native="isChanged()" -->
              <!-- <treeselect
                v-if="field.values"
                :instanceId="`key-${field.key}`"
                v-model="form.values[index]"
                :options="form.fields[index].options"
                :placeholder="field.label"
                :clearable="false"
                :state="fieldValid(field,form.values[index])"
                :disabled="(field.readonly)? (field.readonly.includes(action)):false"
                :class="field.class ? field.class:''"
                @select="isChanged()"
              />-->
              <b-form-invalid-feedback>{{validation}}</b-form-invalid-feedback>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <b-row class="mt-5">
          <b-col class="ml-0">
            <b-button
              style="width: 70px"
              variant="outline-primary"
              size="sm"
              @click="saveData()"
            >Apply</b-button>
            <b-button
              style="width: 70px"
              variant="outline-secondary"
              class="ml-2"
              size="sm"
              @click="show=false"
            >Cancel</b-button>
          </b-col>
        </b-row>
        <!-- {{form.values}} -->
      </b-card>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "TileSettings",
  props: ["tile"],
  data() {
    return {
      title: "Tile Settings",
      show: false,
      busy: false,
      paneindex: 0,
      panes: [],
      values: [],
      action: "update",
      validation: "",
      month_ddl: 12,
      repository_ddl: ""
    };
  },
  watch: {
    show: {
      async handler(newVal, oldVal) {
        console.log("watch:show", newVal, this.tile);
        if (newVal) {
          this.values = [];
          let first = "General";
          this.panes = [
            {
              name: first,
              fields: []
            }
          ];
          if (this.tile.settings) {
            for (var k = 0; k < this.tile.settings.length; k++) {
              this.tile.settings[k].index = k;
              if (!this.tile.settings[k].tab) {
                this.tile.settings[k].tab = first;
              }
              let tab = this.panes.find(
                o => o.name == this.tile.settings[k].tab
              );
              if (!tab) {
                this.panes.push({
                  name: this.tile.settings[k].tab,
                  fields: []
                });
                tab = this.panes.find(o => o.name == this.tile.settings[k].tab);
              }
              tab.fields.push(this.tile.settings[k]);
              this.values.push(this.tile.settings[k].value);
            }
          }
          this.paneindex = 0;
          console.log("tabs=", this.panes);
        } else {
          await this.$emit("cancel");
        }
      }
    }
  },
  methods: {
    async saveData() {
      this.busy = true;
      for (var k = 0; k < this.tile.settings.length; k++) {
        this.tile.settings[k].value = this.values[k];
      }
      await this.$emit("apply", this.tile);
      this.busy = false;
      this.show = false;
    },
    fieldValid(field, value) {
      if (typeof value == "undefined") {
        return null;
      }
      if (field.readonly) {
        if (field.readonly.includes(this.action)) {
          return null;
        }
      }
      // if (field.validation) {
      //   // CLONE FIELDS AND ADD CURRENT DATA, TO SEND IN VALIDATION FUNCTION
      //   let data = [...this.form.fields];
      //   for (var k = 0; k < data.length; k++) {
      //     data[k].value = this.form.values[k];
      //   }
      //   let valid = field.validation(value, field.key, data);
      //   if (!valid) {
      //     this.validation = field.invalid;
      //   } else {
      //     this.validation = "";
      //   }
      //   //console.log("returning validation", valid);
      //   return valid;
      // }
      return null;
    }
  }
};
</script>

<style>
</style>